var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinNodeOffState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 4.33276C9.51561 4.33276 6.69727 7.04543 6.69727 10.3994C6.69727 14.9494 13.0003 21.6661 13.0003 21.6661C13.0003 21.6661 19.3033 14.9494 19.3033 10.3994C19.3033 7.04543 16.4849 4.33276 13.0003 4.33276Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6768 22.9079L13.0001 21.666L14.3235 22.9079L13.0001 24.3181L11.6768 22.9079ZM14.1995 20.289C16.028 18.0848 19.3032 13.6791 19.3032 10.3993C19.3032 7.04531 16.4848 4.33264 13.0001 4.33264C9.51548 4.33264 6.69714 7.04531 6.69714 10.3993C6.69714 13.6791 9.97226 18.0848 11.8008 20.289C12.509 21.1426 13.0001 21.666 13.0001 21.666C11.6768 22.9079 11.6768 22.9079 11.6768 22.9079L11.674 22.9049L11.6689 22.8994L11.652 22.8813L11.5922 22.8165C11.5413 22.761 11.4685 22.681 11.3771 22.5789C11.1943 22.3746 10.9362 22.0809 10.6279 21.7153C10.0129 20.986 9.18968 19.9605 8.36257 18.7806C7.53924 17.6061 6.68802 16.2445 6.03666 14.8451C5.39704 13.4709 4.88232 11.9182 4.88232 10.3993C4.88232 5.97827 8.57918 2.51782 13.0001 2.51782C17.4211 2.51782 21.118 5.97827 21.118 10.3993C21.118 11.9182 20.6032 13.4709 19.9636 14.8451C19.3123 16.2445 18.461 17.6061 17.6377 18.7806C16.8106 19.9605 15.9874 20.986 15.3724 21.7153C15.0641 22.0809 14.806 22.3746 14.6232 22.5789C14.5318 22.681 14.459 22.761 14.408 22.8165L14.3483 22.8813L14.3314 22.8994L14.3263 22.9049L14.3246 22.9067C14.3246 22.9067 14.3235 22.9079 13.0001 21.666C13.0001 21.666 13.4913 21.1426 14.1995 20.289Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6035 8H15.6944H10.5126H9.60352V9V14V15H10.5126H15.6944H16.6035V14V9V8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0481 9.55518H14.543H11.6642H11.1592V10.1107V12.8885V13.4441H11.6642H14.543H15.0481V12.8885V10.1107V9.55518Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinNodeOffState);
export default __webpack_public_path__ + "static/media/Pin-Node-Off-State.696be9699ed85b00c3765314a816f8f1.svg";
export { ForwardRef as ReactComponent };